import React, { Component } from "react";
import {
  profile,
  alert,
  toFixed,
  format_date,
  GET,
  PUT,
  loading,
  Status,
  params,
  DateRangePicker,
  Select,
  Pagination,
  Navbar,
  Modal,
  StatusTnx,
  writeClipboard,
  StatusIcon,
  StatusReason,
  isExpiredCancel,
  CopyCell,
} from "../../components/CustomComponent.js";
import { report_preorder } from "../../components/Report.js";
import {
  report_marketplace_invoice,
  report_marketplace_invoices,
  computeOrderSummary,
  isDigitalOrder,
  describeItem,
} from "../../components/invoice-templates.js";
import {
  DEFAULT_PROCESS_TYPE,
  processTypeStyle,
  PROCESS_TYPE_OPTIONS,
} from "../../components/process-type.js";
import LOGOLARGE from "../../assets/images/logo512.png";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

const countdownInitial = 60;

// every column of the order table, in render order. the column manager builds
// its checkbox list straight from this (same pattern as the Deposit page).
const columnDefs = () => [
  { key: "time", label: "Time" },
  { key: "ref_no", label: "RefNo" },
  { key: "ref_qr", label: "RefQR" },
  { key: "customer", label: "Customer" },
  { key: "bank", label: "Bank" },
  { key: "amount", label: "Amount" },
  { key: "status_payment", label: "Status Payment" },
  { key: "status_order", label: "Status Order" },
  { key: "actions", label: "Actions" },
];

const columnStorageKey = () => "columns-order-marketplace";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const pageSizeStorageKey = () => "page-size-order-marketplace";

const loadPageSize = () => {
  const saved = Number(localStorage.getItem(pageSizeStorageKey()));
  return PAGE_SIZE_OPTIONS.includes(saved) ? saved : 10;
};

const loadColumns = () => {
  const columns = {};
  columnDefs().forEach((column) => {
    columns[column.key] = true;
  });
  try {
    const saved = JSON.parse(localStorage.getItem(columnStorageKey()) || "{}");
    Object.keys(columns).forEach((key) => {
      if (typeof saved[key] === "boolean") columns[key] = saved[key];
    });
  } catch (e) {}
  return columns;
};

// แหล่งที่มาของ order: ลูกค้าสั่งจริงจาก Zenithlink Market หรือ cronjob สร้างให้อัตโนมัติ
const ORDER_SOURCE_DEFAULT = "customer";
const ORDER_SOURCE_OPTIONS = [
  { value: "", label: "All Source" },
  { value: "customer", label: "Customer" },
  { value: "auto", label: "Auto" },
];

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_update: false,
      modal_update_datetime: false,
      modal_detail: false,

      detail: null,
      // ที่อยู่จัดส่งที่แก้ใน modal Update Order (ใช้ออกใบเสร็จ)
      edit_address: "",
      edit_origin: null,
      edit_sub_district: "",
      edit_district: "",
      edit_province: "",
      edit_zipcode: "",
      th_province: [],

      // SEARCH
      filter_status: params("status") || "",
      filter_process_type: "",
      filter_order_source: ORDER_SOURCE_DEFAULT,
      // true = การ์ด Market Order ถูกกด: ตารางกรองด้วยเงื่อนไขเดียวกับตัวเลขบนการ์ด
      filter_market_order: false,
      market_order_count: 0,
      filter_start_date: format_date(
        new Date(new Date().setDate(new Date().getDate() - 30)),
        "yyyy-mm-dd",
        "en",
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_data_search: params("ref_no") || "",
      filter_uid: params("uid") || "",
      filter_search_mode: params("uid") ? "uid" : "general",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      loaded: false,
      count: 10,
      columns: loadColumns(),
      page: 1,
      page_size: loadPageSize(),
      export_progress: null,
      table_updated_at: "",
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      is_topup: false,
      is_hq: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      status_reason: null,
      broker: null,
      customer: null,
      ref_no_refund: "",

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",

      select: -1,
      hover_index: -1,
      hover_info_index: -1,
      hover_monitor_card: "",
      inline_help_popup: null,
      pending_monitor: {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      },
      pending_auto_refresh_enabled: false,
      pending_auto_refresh_countdown: countdownInitial,

      order_uid: "",
      order_status: "",
      order_tracking_list: ""
    };
    this.pendingAutoRefreshInterval = null;
    this.tableRefreshInterval = null;
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  componentWillUnmount() {
    this.StopPendingAutoRefresh();
    this.StopTableAutoRefresh();
  }

  isMarketTransaction = (item) => {
    return Boolean(item?.order?.is_market);
  };

  renderMarketBadge = (item) => {
    if (!this.isMarketTransaction(item)) return null;

    // รายชื่อ process_type ทั้งหมดอยู่ที่ components/process-type.js
    const process_type = item?.order?.process_type || DEFAULT_PROCESS_TYPE;
    const s = processTypeStyle(process_type);

    return (
      <span
        className="ms-2 d-inline-flex align-items-center"
        title={s.label}
        style={{
          padding: "2px 8px",
          borderRadius: 999,
          background: s.background,
          color: s.color,
          border: s.border,
          fontSize: 11,
          lineHeight: 1.2,
          gap: 4,
        }}
      >
        <span className="icon" style={{ fontSize: 10 }}>
          {s.icon}
        </span>
        <span>{s.label}</span>
      </span>
    );
  };

  // order ที่ cronjob สร้างให้อัตโนมัติจะมี created_by ขึ้นต้น "cron:"
  // นอกนั้นคือลูกค้าสั่งซื้อจริงจาก Zenithlink Market Frontend
  isAutoOrder = (item) => {
    return String(item?.order?.created_by || "").startsWith("cron:");
  };

  isCustomerOrder = (item) => {
    return this.isMarketTransaction(item) && !this.isAutoOrder(item);
  };

  renderOrderSourceBadge = (item) => {
    if (!this.isMarketTransaction(item)) return null;

    const isCustomer = this.isCustomerOrder(item);
    const s = isCustomer
      ? {
          label: "Customer",
          title: "ลูกค้าสั่งซื้อจริงจาก Zenithlink Market",
          icon: "\uf007", // user
          background: "#ecfdf5",
          color: "#047857",
          border: "1px solid #bbf7d0",
        }
      : {
          label: "Auto",
          title: "สร้างอัตโนมัติโดย cronjob",
          icon: "\uf013", // cog
          background: "#f1f5f9",
          color: "#64748b",
          border: "1px solid #d8e0ea",
        };

    return (
      <span
        className="ms-1 d-inline-flex align-items-center"
        title={s.title}
        style={{
          padding: "2px 8px",
          borderRadius: 999,
          background: s.background,
          color: s.color,
          border: s.border,
          fontSize: 11,
          lineHeight: 1.2,
          gap: 4,
          fontWeight: isCustomer ? 600 : 400,
        }}
      >
        <span className="icon" style={{ fontSize: 10 }}>
          {s.icon}
        </span>
        <span>{s.label}</span>
      </span>
    );
  };

  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 260;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16,
    );
    const top = Math.max(rect.top - 16, 16);

    this.setState({
      inline_help_popup: {
        ...popup,
        left,
        top,
      },
    });
  };

  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };

  copyInlineHelpText = async (text) => {
    if (!(await writeClipboard(text))) return;
    this.setState((prevState) =>
      prevState.inline_help_popup
        ? {
            inline_help_popup: {
              ...prevState.inline_help_popup,
              copied: true,
            },
          }
        : null,
    );
  };

  setSearchMode = (mode) => {
    this.setState((prevState) => ({
      filter_search_mode: mode,
      filter_data_search:
        mode === "general" ? prevState.filter_data_search : "",
      filter_uid: mode === "uid" ? prevState.filter_uid : "",
    }));
  };

  normalizeTransactionListResponse = (result) => {
    const rows = Array.isArray(result?.data)
      ? result.data
      : result?.data
        ? [result.data]
        : [];

    return {
      rows,
      count: typeof result?.count === "number" ? result.count : rows.length,
    };
  };

  Get = async (page, options = {}) => {
    const { silent = false } = options;
    const {
      filter_search_mode,
      filter_data_search,
      filter_uid,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_order_source,
      filter_market_order,
    } = this.state;
    let data, count, pending_monitor;
    let market_order_count = this.state.market_order_count;
    if (!silent) {
      loading(true);
    }

    let [result, result_pending_monitor, result_market_order] =
      await Promise.all([
        GET(`transactions/deposits/list`, {
          page_size: this.state.page_size,
          page: page,
          uid: filter_search_mode === "uid" ? filter_uid : "",
          data_search:
            filter_search_mode === "general" ? filter_data_search : "",
          start_date: filter_start_date
            ? format_date(filter_start_date, "yyyy-mm-dd", "en")
            : "",
          end_date: filter_end_date
            ? format_date(filter_end_date, "yyyy-mm-dd", "en")
            : "",
          filter_status: filter_status,
          process_type: "",
          order_process_type: filter_process_type,
          order_source: filter_order_source,
          // เงื่อนไขเดียวกับการ์ด Market Order (จ่ายสำเร็จ + ลูกค้าสั่ง + ยังไม่ delivered)
          ...(filter_market_order ? { order_status_exclude: "delivered" } : {}),
          currency: "THB",
          broker_id: "",
          is_market: true,
          is_hq: false,
        }),
        GET(`transactions/deposits/list`, {
          page_size: 1000,
          page: 0,
          uid: "",
          data_search: "",
          start_date: "",
          end_date: "",
          filter_status: "pending",
          process_type: "",
          currency: "THB",
          broker_id: "",
          is_hq: false,
        }),
        // การ์ด Market Order: order ของลูกค้า (tag Customer) ที่จ่ายเงิน success แล้ว
        // และ order ยังไม่ delivered ให้ DB นับทั้งระบบ ขอแค่ count ไม่เอาแถว
        GET(`transactions/deposits/list`, {
          page_size: 1,
          page: 1,
          uid: "",
          data_search: "",
          start_date: "",
          end_date: "",
          filter_status: "success",
          process_type: "",
          order_source: "customer",
          order_status_exclude: "delivered",
          currency: "THB",
          broker_id: "",
          is_market: true,
          is_hq: false,
        }),
      ]);
    if (result_market_order?.status) {
      market_order_count = this.normalizeTransactionListResponse(result_market_order).count;
    }
    if (result?.status) {
      const normalizedResult = this.normalizeTransactionListResponse(result);
      data = normalizedResult.rows;
      count = normalizedResult.count;
    }
    if (result_pending_monitor?.status) {
      const pendingRows = Array.isArray(result_pending_monitor.data)
        ? result_pending_monitor.data
        : [];
      // นับจากอายุของรายการ (created_at) ไม่ใช่ qrs.expired_at
      // QR หมดอายุหลังสร้างรายการอยู่แล้ว การเทียบ expired_at กับ now-20 นาที
      // ทำให้รายการที่ค้างเกิน 20 นาทีจริง ๆ ยังถูกนับเป็น within 20 min
      const nowTime = Date.now();
      const over20Minutes = pendingRows.filter((item) => {
        if (!item?.created_at) return false;
        const createdAt = new Date(item.created_at);
        if (Number.isNaN(createdAt.getTime())) return false;
        return nowTime - createdAt.getTime() > 20 * 60 * 1000;
      }).length;

      pending_monitor = {
        total_pending: pendingRows.length,
        over_20_minutes: over20Minutes,
        within_20_minutes: Math.max(pendingRows.length - over20Minutes, 0),
        updated_at: format_date(new Date(), "dd/mm/yy hh:mm", "en"),
      };
    }
    this.setState({
      data,
      loaded: true,
      count,
      page: page || 1,
      table_updated_at: format_date(new Date(), "hh:mm:ss", "en"),
      market_order_count,
      pending_monitor: pending_monitor || {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      },
      select: silent ? this.state.select : -1,
    });
    if (!silent) {
      loading(false);
    }
  };
   GetByID = async (uid) => {
    let result = await GET("v1/market/orders", { uid });
    if (result?.status) {
      this.setState({detail: result.data})
      // คืนค่าให้ผู้เรียก prefill จากข้อมูลที่ได้จริง (setState ยังไม่ commit ทันที อ่าน this.state.detail ไม่ได้)
      return result.data;
    } else {
      localStorage.clear();
      alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
    }
    return null;
  };
  Update = async () => {
    const {
      order_uid,
      order_status,
      edit_address,
      edit_sub_district,
      edit_district,
      edit_province,
      edit_zipcode,
    } = this.state;
    if (edit_zipcode.trim() && !/^\d{5}$/.test(edit_zipcode.trim())) {
      alert("", "warning", "Warning", "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก");
      return;
    }
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel",
        )
      ) {
        // ที่อยู่ส่งชุดเดียวกันทุก process_type (ใช้ออกใบกำกับภาษี) PUT ตัดค่าว่างทิ้งโดยปริยาย
        // zenith_market: ส่งเหมือนเดิมทุกอย่าง
        // order ของ PresentGateway: keepEmpty และส่งเฉพาะฟิลด์ที่ผู้ใช้แก้จริง (เทียบค่าตอนเปิด modal) ล้างเอง = ส่ง ''
        const is_digital = isDigitalOrder(this.state.detail);
        const address_body = {
          address: edit_address.trim(),
          sub_district: edit_sub_district.trim(),
          district: edit_district.trim(),
          province: edit_province.trim(),
          zipcode: edit_zipcode.trim(),
        };
        const origin = this.state.edit_origin;
        let body = { order_status: order_status };
        Object.entries(address_body).forEach(([key, value]) => {
          if (!is_digital || !origin || value !== (origin[key] || "").trim()) body[key] = value;
        });
        let result = await PUT(`v1/market/orders/` + order_uid, body, is_digital ? { keepEmpty: true } : undefined);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "",
          );
        }
        loading(false);
      
    }
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    
      const _amount = Number(amount);
      const _fee =
        fee_type === "fixed"
          ? Number(fee_rate)
          : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
      const _vat = Number((_fee * 0.07).toFixed(4));
      const amountAfterFee = _amount - _fee;
      let amountNet = is_vat
        ? Number((amountAfterFee - _vat - Number(cost_gateway)).toFixed(4))
        : Number(amountAfterFee.toFixed(4));

      this.setState({
        fee: _fee.toFixed(4),
        amount_net: amountNet.toFixed(4),
        vat: is_vat ? _vat.toFixed(4) : "00.00",
      });
  };
  StartPendingAutoRefresh = () => {
    if (this.pendingAutoRefreshInterval) return;

    this.setState({
      pending_auto_refresh_enabled: true,
      pending_auto_refresh_countdown: countdownInitial,
    });

    this.pendingAutoRefreshInterval = setInterval(async () => {
      const { pending_auto_refresh_enabled, pending_auto_refresh_countdown } =
        this.state;

      if (!pending_auto_refresh_enabled) return;

      if (pending_auto_refresh_countdown <= 1) {
        await this.Get(1, { silent: true });
        this.setState({ pending_auto_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        pending_auto_refresh_countdown: pending_auto_refresh_countdown - 1,
      });
    }, 1000);
  };
  StopPendingAutoRefresh = () => {
    if (this.pendingAutoRefreshInterval) {
      clearInterval(this.pendingAutoRefreshInterval);
      this.pendingAutoRefreshInterval = null;
    }

    this.setState({
      pending_auto_refresh_enabled: false,
      pending_auto_refresh_countdown: countdownInitial,
    });
  };
  TogglePendingAutoRefresh = () => {
    if (this.state.pending_auto_refresh_enabled) {
      this.StopPendingAutoRefresh();
      return;
    }

    this.StartPendingAutoRefresh();
  };
  getPendingMonitorConfig = () => {
    return (
      this.state.pending_monitor || {
        total_pending: 0,
        over_20_minutes: 0,
        within_20_minutes: 0,
        updated_at: "-",
      }
    );
  };


  // ---- Table controls (same behaviour as the Deposit page) --------------
  setPageSize = (page_size) => {
    localStorage.setItem(pageSizeStorageKey(), String(page_size));
    this.setState({ page_size }, () => {
      this.Get(1);
    });
  };

  resetColumns = () => {
    localStorage.removeItem(columnStorageKey());
    this.setState({ columns: loadColumns() });
  };

  StartTableAutoRefresh = () => {
    if (this.tableRefreshInterval) return;

    this.setState({
      table_auto_refresh: true,
      table_refresh_countdown: countdownInitial,
    });

    this.tableRefreshInterval = setInterval(async () => {
      const { table_auto_refresh, table_refresh_countdown, page } = this.state;

      if (!table_auto_refresh) return;

      if (table_refresh_countdown <= 1) {
        // silent + current page: refreshing must not steal the row the user
        // is reading or flash the full-screen loader
        await this.Get(page, { silent: true });
        this.setState({ table_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        table_refresh_countdown: table_refresh_countdown - 1,
      });
    }, 1000);
  };

  StopTableAutoRefresh = () => {
    if (this.tableRefreshInterval) {
      clearInterval(this.tableRefreshInterval);
      this.tableRefreshInterval = null;
    }

    this.setState({
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
    });
  };

  ToggleTableAutoRefresh = () => {
    if (this.state.table_auto_refresh) {
      this.StopTableAutoRefresh();
      return;
    }

    this.StartTableAutoRefresh();
  };

  isColumn = (key) => this.state.columns?.[key] !== false;

  toggleColumn = (key) => {
    this.setState((prevState) => {
      const columns = { ...prevState.columns, [key]: !prevState.columns[key] };
      localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
      return { columns };
    });
  };

  toggleAllColumns = (checked) => {
    const columns = {};
    columnDefs().forEach((column) => {
      columns[column.key] = checked;
    });
    localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
    this.setState({ columns });
  };

  // ---- Market Order card filter ------------------------------------------
  defaultFilters = () => ({
    filter_status: params("status") || "",
    filter_process_type: "",
    filter_order_source: ORDER_SOURCE_DEFAULT,
    filter_market_order: false,
    filter_start_date: format_date(
      new Date(new Date().setDate(new Date().getDate() - 30)),
      "yyyy-mm-dd",
      "en",
    ),
    filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
    filter_data_search: params("ref_no") || "",
    filter_uid: params("uid") || "",
    filter_search_mode: params("uid") ? "uid" : "general",
  });

  ResetFilters = () => {
    this.setState(this.defaultFilters(), () => this.Get(1));
  };

  // กดการ์ด Market Order: กรองตารางให้ตรงกับตัวเลขบนการ์ด (ไม่จำกัดช่วงวันที่)
  // กดซ้ำ = กลับไปใช้ filter ค่าเริ่มต้น
  ToggleMarketOrderFilter = () => {
    if (this.state.filter_market_order) {
      this.ResetFilters();
      return;
    }
    this.setState(
      {
        ...this.defaultFilters(),
        filter_market_order: true,
        filter_status: "success",
        filter_order_source: "customer",
        filter_start_date: "",
        filter_end_date: "",
      },
      () => this.Get(1),
    );
  };

  GotoProduct = async (product_code) => {
     let [result] = await Promise.all([
      GET("v1/market/products", { product_code }),
    ]);
    if (result?.status) {
      window.open(result.data.remark,"_blank")
    }
  }

  // --- Helper Methods ---

  handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = LOGOLARGE;
  };

  // Export Invoice All: ใบกำกับภาษี/ใบเสร็จของทุก order ที่ตรงกับ filter ปัจจุบัน (ทุกหน้า) เป็น PDF เดียว ใบละหน้า
  // ข้าม order ที่ไม่มี order หรือยังชำระไม่สำเร็จ
  ExportInvoiceAll = async () => {
    if (this.state.export_progress) return;
    const {
      count,
      filter_search_mode,
      filter_data_search,
      filter_uid,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_order_source,
      filter_market_order,
    } = this.state;
    if (!count) {
      alert("", "warning", "Export Invoice All", "ไม่มีรายการที่ตรงกับ filter");
      return;
    }
    const warn = count > 500 ? `\nรายการมาก (เกิน 500) อาจใช้เวลานานและไฟล์ใหญ่ แนะนำให้แคบ filter ลงก่อน` : "";
    if (
      !(await alert(
        "",
        count > 500 ? "warning" : "info",
        "Export Invoice All",
        `ออกใบกำกับภาษี/ใบเสร็จของ ${count} รายการตาม filter ปัจจุบัน (เฉพาะที่ชำระสำเร็จ) เป็น PDF ไฟล์เดียว${warn}`,
        "Confirm",
        "Cancel",
      ))
    )
      return;

    const PAGE = 100;
    const CONCURRENCY = 5;
    const date_text = (d) => (d ? format_date(d, "yyyy-mm-dd", "en") : "");
    this.setState({ export_progress: { done: 0, total: 0 } });
    try {
      // 1) รายการทุกหน้า (พารามิเตอร์เดียวกับ Get)
      const rows = [];
      for (let page = 1; ; page++) {
        const result = await GET(`transactions/deposits/list`, {
          page_size: PAGE,
          page,
          uid: filter_search_mode === "uid" ? filter_uid : "",
          data_search: filter_search_mode === "general" ? filter_data_search : "",
          start_date: date_text(filter_start_date),
          end_date: date_text(filter_end_date),
          filter_status: filter_status,
          process_type: "",
          order_process_type: filter_process_type,
          order_source: filter_order_source,
          ...(filter_market_order ? { order_status_exclude: "delivered" } : {}),
          currency: "THB",
          broker_id: "",
          is_market: true,
          is_hq: false,
        });
        if (!result?.status) {
          alert("", "warning", "Export Invoice All", result?.message || "โหลดรายการไม่สำเร็จ");
          return;
        }
        const page_rows = this.normalizeTransactionListResponse(result).rows;
        rows.push(...page_rows);
        if (page_rows.length < PAGE) break;
      }

      // 2) เฉพาะแถวที่มี order และชำระสำเร็จ (ไม่ซ้ำ order)
      const seen = new Set();
      const eligible = rows.filter((row) => {
        const uid = row?.order?.uid;
        if (!uid || row?.status !== "success" || seen.has(uid)) return false;
        seen.add(uid);
        return true;
      });
      const skipped = rows.length - eligible.length;
      if (!eligible.length) {
        alert("", "warning", "Export Invoice All", `ไม่มีใบที่ออกได้ (ข้าม ${skipped} รายการ: ไม่มี order หรือยังไม่ชำระสำเร็จ)`);
        return;
      }

      // 3) detail ของแต่ละ order พร้อมกันไม่เกิน CONCURRENCY
      this.setState({ export_progress: { done: 0, total: eligible.length } });
      const details = new Array(eligible.length).fill(null);
      let next = 0;
      let done = 0;
      const worker = async () => {
        while (next < eligible.length) {
          const index = next++;
          const result = await GET("v1/market/orders", { uid: eligible[index].order.uid });
          if (result?.status && result.data?.order_items?.length) details[index] = result.data;
          done++;
          this.setState({ export_progress: { done, total: eligible.length } });
        }
      };
      await Promise.all(Array.from({ length: Math.min(CONCURRENCY, eligible.length) }, worker));
      const orders = details.filter(Boolean);
      const failed = eligible.length - orders.length;
      if (!orders.length) {
        alert("", "warning", "Export Invoice All", "โหลดรายละเอียด order ไม่สำเร็จ");
        return;
      }

      // 4) PDF เดียว
      await report_marketplace_invoices(
        orders,
        `invoices_${date_text(filter_start_date) || "all"}_${date_text(filter_end_date) || "all"}.pdf`,
      );
      alert(
        "",
        "success",
        "Export Invoice All",
        `ออกใบแล้ว ${orders.length} ใบ · ข้าม ${skipped} (ไม่มี order/ยังไม่ชำระสำเร็จ)${failed ? ` · โหลดไม่สำเร็จ ${failed}` : ""}`,
      );
    } catch (error) {
      alert("", "warning", "Export Invoice All", "ไม่สามารถสร้างเอกสารได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      this.setState({ export_progress: null });
    }
  };

  // ดาวน์โหลดเอกสารของออเดอร์ (report_tax_invoice / report_preorder) เป็น PDF
  DownloadReport = async (report, detail) => {
    if (!detail?.order_items?.length) return;
    loading(true);
    try {
      await report(detail);
    } catch (error) {
      alert("", "warning", "แจ้งเตือน", "ไม่สามารถสร้างเอกสารได้ กรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  // โหลดข้อมูลจังหวัด/อำเภอ/ตำบลตอนเปิด Update Order ครั้งแรก (ไฟล์ใหญ่ แยก chunk ไม่ให้หน้าโหลดช้า)
  LoadProvince = async () => {
    if (this.state.th_province.length) return;
    try {
      const data = await import("../../assets/files/th_province.json");
      this.setState({ th_province: data.default || data });
    } catch (error) {
      // โหลดไม่ได้ Select จะเหลือแค่ค่าเดิมของออเดอร์ ไม่ต้องล้มทั้ง modal
    }
  };

  // ค่าเดิมของออเดอร์ที่ไม่ตรงกับรายชื่อในไฟล์ (เช่นพิมพ์เองมาก่อน) ให้ยังเห็นและคงไว้ได้
  withCurrentOption = (options, current) =>
    current && !options.some((option) => option.value === current)
      ? [{ value: current, label: current }, ...options]
      : options;

  // ปัดเศษสตางค์ให้ลงท้าย 5 สตางค์ ตามสูตรหน้าตะกร้าของ Zenithlink-Market-Frontend
  roundDecimalToNearest = (num) => {
    let baht = Math.floor(num);
    let satang = Math.round((num - baht) * 100);
    let rounded_satang = Math.round(satang / 5) * 5;
    if (rounded_satang >= 100) {
      baht += 1;
      rounded_satang = 0;
    }
    return baht + rounded_satang / 100;
  };

  // ค่าจัดส่ง (market) / ค่าดำเนินการ (CRM ฯลฯ) มาจาก orders.fee ส่วน VAT ไม่มีเก็บใน DB จึงคำนวณใหม่ 7% ของราคาสินค้า
  // ตามสูตรเดียวกับตะกร้าของ Zenithlink-Market-Frontend (src/page/customer/cart.js) — สูตรอยู่ที่ computeOrderSummary
  getOrderSummary = (detail) => {
    const summary = computeOrderSummary(detail);
    const is_digital = isDigitalOrder(detail);
    return {
      subtotal: summary.subtotal,
      vat: summary.vat,
      vat_included: summary.vat_mode === "included",
      transport: summary.fee,
      discount: summary.discount,
      amount: summary.amount,
      is_digital,
      fee_label: is_digital ? "ค่าดำเนินการ" : "ค่าจัดส่ง",
    };
  };

  renderOrderItem = (order, index, is_digital = false) => {
    const Main = is_digital ? "div" : "a";
    const main_props = is_digital ? {} : { href: `/product-detail?pc=${order.product_code}` };
    const item_note = is_digital ? describeItem(order) : "";
    return (
    <div key={index} className="pu-om-item">
      <Main className="pu-om-item-main" {...main_props}>
        <img
          alt="THUMBNAIL"
          src={order?.product_image || LOGOLARGE}
          className="pu-om-item-img"
          loading="lazy"
          onError={this.handleImgError}
        />
        <div className="min-w-0">
          <div className="pu-om-item-name">{order.product_name}</div>
          <div className="pu-om-item-price">฿{toFixed(order.price)}</div>
          {item_note ? <div className="pu-sub">{item_note}</div> : null}
        </div>
      </Main>
      <div className="pu-om-item-side">
        <div className="pu-sub justify-content-end">x{order.quantity}</div>
        <div className="pu-amount">
          ฿{toFixed(Number(order.price) * Number(order.quantity))}
        </div>
        {profile?.user_type === "super_user" && !is_digital && (
          <button
            type="button"
            className="pu-om-item-link icon"
            title="Open product"
            onClick={() => {
              this.GotoProduct(order.product_code);
            }}
          >
            {"\uf0c1"}
          </button>
        )}
      </div>
    </div>
    );
  };

  renderStatusBadge = (item) => {
    const status = item?.order?.order_status;
    const status_payment = item?.status;
    if (status_payment === "cancel") return Status("cancelled", "danger");
    if (status === "pending") return status_payment === "success" ? Status("preparing", "orange") : Status("awaiting payment", "warning");
    if (status === "preparing") return Status("preparing", "orange");
    if (status === "delivering") return Status("delivering", "info");
    if (status === "success") return Status("delivered", "success");
    if (status === "returned") return Status("returned", "secondary");
    if (status === "cancel") return Status("cancelled", "danger");
    return null;
  };

 renderModalBanner = (detail) => {
  if (!detail?.transaction) return null;
  const status = detail.order_status;
  const status_payment = detail.transaction.status;

  // 1. กรณีถูกยกเลิก (Cancel) แสดงเป็น Banner แจ้งเตือนสีแดง
  if (status === "cancel" || status_payment === "cancel") {
    return (
      <div className="rounded-4 p-4 bg-danger text-white mb-2" style={{ lineHeight: "1.6" }}>
        <h4 className="mb-2 fw-bold">
          <span className="icon me-2">{"\uf00d"}</span> ยกเลิกรายการ
        </h4>
        <div>คำสั่งซื้อของคุณถูกยกเลิกเรียบร้อยแล้ว</div>
        <small className="opacity-75">หากมีข้อสงสัย กรุณาติดต่อผู้ขายหรือฝ่ายบริการลูกค้า</small>
      </div>
    );
  }

  // 2. กรณีคืนสินค้า (Returned) แสดงเป็น Banner แจ้งเตือนสีส้มอ่อน/เหลืองทอง
  if (status === "returned") {
    return (
      <div className="rounded-4 p-4 mb-2" style={{ backgroundColor: "#fff3cd", color: "#856404", border: "1px solid #ffeeba", lineHeight: "1.6" }}>
        <h4 className="mb-2 fw-bold">
          <span className="icon me-2">{"\uf0e2"}</span> คืนเงิน / คืนสินค้า {/* \uf0e2 คือ fa-undo */}
        </h4>
        <div>คำสั่งซื้อนี้ถูกดำเนินการคืนเงินหรือคืนสินค้าเรียบร้อยแล้ว</div>
        <small className="opacity-75">ยอดเงินจะถูกคืนเข้าสู่ช่องทางชำระเงินของคุณตามระยะเวลาที่กำหนด</small>
      </div>
    );
  }

  // --- คำนวณสถานะปัจจุบัน (0 ถึง 3) ---
  let currentStep = 0; // ค่าเริ่มต้น: มีคำสั่งซื้อใหม่ (Pending)

  // แก้ไขบั๊กเดิม: ลบคำว่า return ออก เพื่อไม่ให้ฟังก์ชันหยุดทำงานก่อนที่จะ Render UI ด้านล่าง
  if (status === "pending") {
    currentStep = status_payment === "success" ? 1 : 0;
  } else if (status === "preparing") {
    currentStep = 1;
  } else if (status === "delivering") {
    currentStep = 2;
  } else if (status === "success") {
    currentStep = 3;
  }

  // --- กำหนดข้อมูลของแต่ละสเต็ป ---
  const is_digital = isDigitalOrder(detail);
  const all_steps = [
    { 
      label: "มีคำสั่งซื้อใหม่", 
      date: detail.created_at ? format_date(detail.created_at, "dd/mm/yyyy hh:mm") : "-", 
      icon: "\uf022" // fa-list-alt
    },
    { 
      label: "ชำระเงินแล้ว/รอจัดส่ง", 
      date: detail.transaction?.payment_date || "-",
      icon: "\uf0d6" // fa-money
    },
    { 
      label: "กำลังจัดส่ง", 
      date: detail.shipped_date || "", 
      icon: "\uf0d1" // fa-truck
    },
    { 
      label: "ทำการจัดส่งแล้ว", 
      date: detail.delivered_date || detail.shipped_date || "", 
      icon: "\uf058" // เปลี่ยนจากรถบรรทุกซ้ำ เป็น fa-check-circle เพื่อให้ดูสำเร็จ
    }
  ];
  // order ของ PresentGateway (CRM ฯลฯ) ไม่มีการจัดส่ง: เหลือแค่ สร้างคำสั่งซื้อ -> ชำระเงินแล้ว (สถานะ success/delivering นับเป็นชำระแล้ว)
  const steps = is_digital
    ? [all_steps[0], { ...all_steps[1], label: "ชำระเงินแล้ว" }]
    : all_steps;
  if (is_digital) currentStep = Math.min(currentStep, steps.length - 1);

  return (
    <div className="bg-white rounded-4 p-3 mb-2 border">
      <div className="d-flex justify-content-between align-items-start w-100 mt-2 mb-2 overflow-hidden">
        
        {steps.map((step, index) => {
          const isCompleted = index <= currentStep;
          
          // สเต็ปสุดท้าย (ให้คะแนน) ถ้าทำสำเร็จแล้ว จะทำพื้นหลังทึบ
          const isLastActive = index === steps.length - 1 && isCompleted; 
          
          // การตั้งค่าสี
          const circleBg = isLastActive ? '#22c55e' : '#ffffff';
          const iconColor = isLastActive ? '#ffffff' : (isCompleted ? '#22c55e' : '#d1d5db');
          const borderColor = isCompleted ? '#22c55e' : '#e5e7eb';

          return (
            <div key={index} className="d-flex flex-column align-items-center position-relative flex-fill">
              
              {/* เส้นเชื่อม */}
              {index !== 0 && (
                <div 
                  className="position-absolute" 
                  style={{
                    top: '28px', // ครึ่งหนึ่งของความสูงวงกลม (56px)
                    right: '50%',
                    width: '100%',
                    height: '4px',
                    // ปรับให้เส้นเป็นสีเขียวเฉพาะตอนที่ข้ามสเต็ปนั้นไปแล้ว
                    backgroundColor: index <= currentStep ? '#22c55e' : '#e5e7eb', 
                    zIndex: 0,
                    transition: 'background-color 0.3s ease'
                  }}
                ></div>
              )}

              {/* วงกลม Icon */}
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center mb-3 position-relative"
                style={{
                  width: '56px', height: '56px',
                  border: `4px solid ${borderColor}`,
                  backgroundColor: circleBg,
                  color: iconColor,
                  fontSize: '24px',
                  zIndex: 1, // ให้อยู่เหนือเส้นเชื่อม
                  transition: 'all 0.3s ease'
                }}
              >
                <span className="icon">{step.icon}</span>
              </div>

              {/* ข้อความ (Label) */}
              <div 
                className="text-12 fw-bold text-center px-2" 
                style={{ 
                  color: isCompleted ? '#374151' : '#9ca3af', 
                  lineHeight: '1.4'
                }}
              >
                {step.label}
              </div>
              
              {/* วันที่ (Date) */}
              <div className="text-10 mt-1 text-center" style={{ color: '#9ca3af', minHeight: '15px' }}>
                {step.date || '\u00A0'} 
              </div>

            </div>
          )
        })}

      </div>
    </div>
  );
};


  // Skeleton สำหรับการเลื่อนโหลด
  renderSkeleton = () => {
    return Array.from({ length: 3 }).map((_, index) => (
      <div key={`skeleton-${index}`} className="card rounded-4 mb-3 p-3">
        <div className="d-flex flex-wrap justify-content-between placeholder-glow">
          <div className="d-flex mb-3">
            <div className="wpx-100 hpx-100 bg-secondary rounded-4 placeholder" style={{ opacity: 0.2 }}></div>
            <div className="ps-3 d-flex flex-column justify-content-center">
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "100px", height: "18px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "180px", height: "18px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3" style={{ width: "80px", height: "18px", opacity: 0.2 }}></div>
            </div>
          </div>
          <div className="d-flex align-items-start">
            <div className="placeholder bg-secondary rounded-5" style={{ width: "90px", height: "30px", opacity: 0.2 }}></div>
          </div>
        </div>
        <hr />
        <div className="placeholder-glow mb-2">
          <div className="placeholder bg-secondary rounded-3" style={{ width: "100px", height: "18px", opacity: 0.2 }}></div>
        </div>
        <div className="d-flex justify-content-between border-bottom pt-3 pb-2 placeholder-glow">
          <div className="d-flex w-100">
            <div className="wpx-40 hpx-40 bg-secondary rounded-4 placeholder" style={{ opacity: 0.2 }}></div>
            <div className="px-3 w-100">
              <div className="placeholder bg-secondary rounded-3 mb-2" style={{ width: "60%", height: "14px", opacity: 0.2 }}></div>
              <div className="placeholder bg-secondary rounded-3" style={{ width: "30%", height: "14px", opacity: 0.2 }}></div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  // ---- Order info shared by Update / Detail modals ----------------------
  renderAddressText = (detail) =>
    `${detail?.address || ""} ${detail?.sub_district ? "ต." + detail?.sub_district : ""} ${detail?.district ? "อ." + detail?.district : ""} ${detail?.province ? "จ." + detail?.province : ""} ${detail?.zipcode || ""}`;

  renderOrderInfo = (detail, editable) => {
    const {
      edit_address,
      edit_sub_district,
      edit_district,
      edit_province,
      edit_zipcode,
      th_province,
    } = this.state;
    const order_summary = this.getOrderSummary(detail);
    const is_digital = order_summary.is_digital;
    // ตัวเลือกที่อยู่แบบเลือกต่อกัน จังหวัด → อำเภอ → ตำบล
    const province_data = th_province.find((item) => item.th === edit_province);
    const district_data = province_data?.district?.find((item) => item.th === edit_district);
    const province_options = this.withCurrentOption(
      th_province.map((item) => ({ value: item.th, label: item.th })),
      edit_province,
    );
    const district_options = this.withCurrentOption(
      (province_data?.district || []).map((item) => ({ value: item.th, label: item.th })),
      edit_district,
    );
    const sub_district_options = this.withCurrentOption(
      (district_data?.sub_district || []).map((item) => ({ value: item.th, label: item.th })),
      edit_sub_district,
    );
    return (
      <>
        {/* สถานะการสั่งซื้อ */}
        {this.renderModalBanner(detail)}

        {/* ที่อยู่ (order ของ PresentGateway: หน้ารายละเอียดแสดงเมื่อมีที่อยู่ หน้า Update แก้ได้เหมือน zenith_market) */}
        {(!is_digital || editable || this.renderAddressText(detail).trim()) && (
        <div className="pu-section">
          <div className="pu-section-title">
            <span className="icon">{""}</span>{is_digital ? "ที่อยู่" : "ที่อยู่ในการจัดส่ง"}
          </div>
          <div className="pu-om-contact">
            <span className="pu-avatar">
              {(detail?.customer?.name_en || detail?.customer?.name_th || "?")
                .charAt(0)
                .toUpperCase()}
            </span>
            <div>
              <div className="pu-name">
                {detail?.customer?.name_en || detail?.customer?.name_th || " "}
              </div>
              <div className="pu-sub">{detail?.customer?.phone || "-"}</div>
            </div>
          </div>
          {editable ? (
            <>
              <div className="row g-2 mt-2">
                <div className="col-12">
                  <label className="pr-label">ที่อยู่</label>
                  <textarea
                    className="form-control pr-input"
                    rows={2}
                    maxLength={1000}
                    placeholder="บ้านเลขที่ หมู่ ซอย ถนน..."
                    value={edit_address}
                    onChange={(e) => this.setState({ edit_address: e.target.value })}
                  />
                </div>
                <div className="col-6 col-md-3">
                  <div className="mb-2">
                    <label className="pr-label">จังหวัด</label>
                    <Select
                      className="form-control pr-input"
                      placeholder="เลือกจังหวัด..."
                      options={province_options}
                      value={edit_province}
                      onChange={(v) =>
                        v !== edit_province &&
                        this.setState({
                          edit_province: v,
                          edit_district: "",
                          edit_sub_district: "",
                          edit_zipcode: "",
                        })
                      }
                    />
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="mb-2">
                    <label className="pr-label">อำเภอ/เขต</label>
                    <Select
                      className="form-control pr-input"
                      placeholder={edit_province ? "เลือกอำเภอ/เขต..." : "เลือกจังหวัดก่อน"}
                      options={district_options}
                      value={edit_district}
                      disabled={!edit_province}
                      onChange={(v) =>
                        v !== edit_district &&
                        this.setState({ edit_district: v, edit_sub_district: "", edit_zipcode: "" })
                      }
                    />
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="mb-2">
                    <label className="pr-label">ตำบล/แขวง</label>
                    <Select
                      className="form-control pr-input"
                      placeholder={edit_district ? "เลือกตำบล/แขวง..." : "เลือกอำเภอก่อน"}
                      options={sub_district_options}
                      value={edit_sub_district}
                      disabled={!edit_district}
                      onChange={(v) => {
                        // เลือกตำบลแล้วเติมรหัสไปรษณีย์ให้อัตโนมัติ (ยังแก้เองได้)
                        const code = district_data?.sub_district?.find((item) => item.th === v)?.code;
                        this.setState({
                          edit_sub_district: v,
                          edit_zipcode: code ? String(code) : edit_zipcode,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className="mb-2">
                    <label className="pr-label">รหัสไปรษณีย์</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      className="form-control pr-input"
                      maxLength={5}
                      value={edit_zipcode}
                      onChange={(e) =>
                        this.setState({
                          edit_zipcode: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="pu-hint">
                {is_digital ? "กด Submit เพื่อบันทึก ที่อยู่นี้จะใช้ออกใบกำกับภาษี / ใบเสร็จรับเงิน" : "กด Submit เพื่อบันทึก ที่อยู่นี้จะใช้ออกใบเสร็จรับเงิน / ใบ PreOrder"}
              </div>
            </>
          ) : (
            <div className="pu-om-address">{this.renderAddressText(detail)}</div>
          )}
        </div>
        )}

        {/* รายการสินค้า */}
        <div className="pu-section">
          <div className="pu-section-title">
            <span className="icon">{""}</span>รายการสินค้า
            <span className="pu-cc-count ms-auto">
              {detail?.order_items?.length || 0} item
              {(detail?.order_items?.length || 0) === 1 ? "" : "s"}
            </span>
          </div>
          {detail?.order_items?.map((order, index) => this.renderOrderItem(order, index, is_digital))}
        </div>

        {/* รายละเอียดการสั่งซื้อ */}
        <div className="pu-section pu-section-gold">
          <div className="pu-section-title">
            <span className="icon">{""}</span>รายละเอียดการสั่งซื้อ
          </div>
          {this.kv(
            "หมายเลขคำสั่งซื้อ",
            `#${detail?.order_no || ""}-${detail?.transaction?.reference_id || ""}`
          )}
          {order_summary.discount > 0 &&
            this.kv("ส่วนลด", `-฿${toFixed(order_summary.discount)}`)}
          {this.kv(order_summary.fee_label, `฿${toFixed(order_summary.transport)}`)}
          {this.kv(
            is_digital && order_summary.vat_included ? "ภาษีมูลค่าเพิ่ม (VAT 7% รวมในราคาแล้ว)" : "ภาษีมูลค่าเพิ่ม (VAT 7%)",
            `฿${toFixed(order_summary.vat)}`
          )}
          {this.kv("ชำระผ่าน", "QRCode - พร้อมเพย์ Promptpay")}
          {this.kv(
            "วันเวลาที่สั่งซื้อ",
            format_date(detail?.created_at, "dd/mm/yyyy hh:mm") || ""
          )}
          {this.kv("หมายเหตุ", detail?.remark || detail?.delivery_remark || "-")}
          <div className="pu-kv total">
            <span className="pu-kv-label">ยอดรวมทั้งสิ้น</span>
            <span className="pu-kv-value pu-amount-gold">
              ฿{toFixed(order_summary.amount)}
            </span>
          </div>
        </div>

        {/* ดาวน์โหลดเอกสาร */}
        <div className="d-flex justify-content-end gap-2 mb-2">
          {!is_digital && Number(detail?.total_price) > 10000 && (
            <button
              className="pu-doc-btn"
              disabled={!detail?.order_items?.length}
              onClick={() => this.DownloadReport(report_preorder, detail)}
            >
              <span className="icon me-2">{""}</span>PreOrder
            </button>
          )}
          <button
            className="pu-doc-btn gold"
            disabled={!detail?.order_items?.length}
            onClick={() => this.DownloadReport(report_marketplace_invoice, detail)}
          >
            <span className="icon me-2">{""}</span>ใบเสร็จรับเงิน
          </button>
        </div>
      </>
    );
  };
  kv = (label, value) => (
    <div className="pu-kv">
      <span className="pu-kv-label">{label}</span>
      <span className="pu-kv-value">{value}</span>
    </div>
  );

  render() {
    const {
      select,
      detail,
      modal_update,
      modal_detail,

      filter_process_type,
      filter_order_source,
      filter_market_order,
      market_order_count,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_uid,
      filter_search_mode,
      data,
      loaded,
      count,
      page,
      page_size,
      table_updated_at,
      table_auto_refresh,
      table_refresh_countdown,

      hover_index,
      hover_info_index,
      hover_monitor_card,
      inline_help_popup,
      pending_auto_refresh_enabled,
      pending_auto_refresh_countdown,

      order_status,
      order_tracking_list,
    } = this.state;
    const pendingMonitor = this.getPendingMonitorConfig();
    // การ์ด Market Order: DB นับให้ทั้งระบบ = tag Customer + payment success + order ยังไม่ delivered
    const marketMonitorCount = market_order_count;
    const focusedRowIndex =
      hover_info_index !== -1
        ? hover_info_index
        : hover_index !== -1
          ? hover_index
          : -1;
    const hasFocusedOverlay =
      Boolean(hover_monitor_card) ||
      hover_index !== -1 ||
      hover_info_index !== -1;
    const visibleColumns = columnDefs().filter((column) => this.isColumn(column.key));
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div
            className={`market-monitor-overlay ${hasFocusedOverlay ? "show" : ""}`}
          ></div>
          {inline_help_popup && (
            <div
              className="inline-help-popup"
              style={{
                left: inline_help_popup.left,
                top: inline_help_popup.top,
              }}
            >
              <div
                className="fw-semibold mb-1"
                style={{
                  fontSize: 12,
                  color: inline_help_popup.titleColor || "#344054",
                }}
              >
                {inline_help_popup.title}
              </div>
              {inline_help_popup.lines?.map((line, idx) => (
                <div key={`inline-help-${idx}`} className="text-14">
                  {line}
                </div>
              ))}
              {inline_help_popup.copyable && (
                <div
                  className="fw-semibold mt-1"
                  style={{
                    fontSize: 11,
                    color: inline_help_popup.copied ? "#079455" : "#98a2b3",
                  }}
                >
                  {inline_help_popup.copied ? "Copied!" : "Click to copy"}
                </div>
              )}
            </div>
          )}

          {/* HERO */}
          <div className="ar-hero pu-om-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Marketplace</div>
                <div className="ar-title">Order Marketplace Management</div>
                <div className="ar-subtitle">
                  Manage and monitor Order Marketplace transactions
                </div>
              </div>

              {/* PENDING MONITOR */}
              <div className="pu-om-monitor">
                <div className="pu-om-monitor-meta">
                  <div className="pu-om-monitor-label">Pending Monitor</div>
                  <div className="pu-om-monitor-updated">
                    Updated {pendingMonitor.updated_at}
                  </div>
                </div>
                <div
                  role="button"
                  tabIndex={0}
                  title={
                    filter_market_order
                      ? "Click to clear the Market Order filter"
                      : "Click to show only these orders in the table"
                  }
                  className={`pu-om-kpi pu-om-kpi-btn market-monitor-card ${hover_monitor_card === "market_order" ? "is-active" : ""} ${filter_market_order ? "active" : ""}`}
                  onMouseEnter={() =>
                    this.setState({ hover_monitor_card: "market_order" })
                  }
                  onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                  onClick={this.ToggleMarketOrderFilter}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      this.ToggleMarketOrderFilter();
                    }
                  }}
                >
                  <div className="pu-om-kpi-label">
                    <span className="icon me-1">
                      {filter_market_order ? "\uf0b0" : "\uf07a"}
                    </span>
                    Market Order
                  </div>
                  <div className="pu-om-kpi-value">{marketMonitorCount}</div>
                  <div className="market-monitor-tooltip">
                    <div
                      className="fw-semibold mb-1"
                      style={{ fontSize: 13, color: "#0d6efd" }}
                    >
                      Market Order
                    </div>
                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                      Orders placed by customers on{" "}
                      <span className="fw-semibold">Zenithlink Market</span>{" "}
                      (tag Customer) with payment status{" "}
                      <span className="fw-semibold">success</span> and order
                      status not yet <span className="fw-semibold">delivered</span>.
                      Auto orders created by cronjob are not counted.
                    </div>
                    <div
                      className="fw-semibold mt-2"
                      style={{ fontSize: 12, color: "#8a5300" }}
                    >
                      {filter_market_order
                        ? "Filter is on — click again to clear."
                        : "Click to filter the table to these orders."}
                    </div>
                  </div>
                </div>
                <div
                  className={`market-monitor-card ${hover_monitor_card === "auto_update" ? "is-active" : ""}`}
                  onMouseEnter={() =>
                    this.setState({ hover_monitor_card: "auto_update" })
                  }
                  onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                >
                  <button
                    type="button"
                    className={`pu-om-kpi pu-om-kpi-btn ${pending_auto_refresh_enabled ? "active" : ""}`}
                    onClick={this.TogglePendingAutoRefresh}
                  >
                    <div className="pu-om-kpi-label">
                      <span className="icon me-1">{""}</span>Auto Update
                    </div>
                    <div className="pu-om-kpi-value">
                      {pending_auto_refresh_enabled
                        ? `${pending_auto_refresh_countdown}s`
                        : "Off"}
                    </div>
                  </button>
                  <div className="market-monitor-tooltip">
                    <div
                      className="fw-semibold mb-1"
                      style={{ fontSize: 13, color: "#8a5300" }}
                    >
                      Auto Update
                    </div>
                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                      Turn automatic refresh for the pending monitor on or off.
                      The data updates based on the countdown timer.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FILTER */}
            <div className="ar-toolbar pu-om-filter mt-3">
              <div className="pu-om-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
                <span className="ar-toolbar-hint">
                  Press Enter in the search box or click Search to apply
                </span>
              </div>
              <div className="pu-om-filter-grid">
                <div className="pu-om-field pu-om-field-search">
                  <span className="pu-om-field-label">
                    {filter_search_mode === "uid" ? "Transaction UID" : "Search"}
                  </span>
                  <div className="pu-om-search">
                    <span className="icon pu-om-search-icon">
                      {filter_search_mode === "uid" ? "\uf084" : "\uf002"}
                    </span>
                    <input
                      type="text"
                      placeholder={
                        filter_search_mode === "uid"
                          ? "Paste transaction UID here..."
                          : "Ref no. / customer..."
                      }
                      onChange={(e) => {
                        this.setState(
                          filter_search_mode === "uid"
                            ? { filter_uid: e.target.value }
                            : { filter_data_search: e.target.value },
                        );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.Get(1);
                      }}
                      value={
                        filter_search_mode === "uid" ? filter_uid : filter_data_search
                      }
                    />
                    <div className="pu-om-modes">
                      <div
                        className={`filter-search-mode-trigger market-monitor-card ${hover_monitor_card === "search_general" ? "is-active" : ""}`}
                        onMouseEnter={() =>
                          this.setState({ hover_monitor_card: "search_general" })
                        }
                        onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                      >
                        <button
                          type="button"
                          className={`pu-om-mode ${filter_search_mode === "general" ? "active" : ""}`}
                          onClick={() => this.setSearchMode("general")}
                        >
                          <span className="icon">{"\uf002"}</span>
                        </button>
                        <div className="market-monitor-tooltip">
                          <div
                            className="fw-semibold mb-1"
                            style={{ fontSize: 13, color: "#8a5300" }}
                          >
                            General Search
                          </div>
                          <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                            Search by <span className="fw-semibold">Ref no.</span> or{" "}
                            <span className="fw-semibold">customer</span>.
                          </div>
                        </div>
                      </div>
                      <div
                        className={`filter-search-mode-trigger market-monitor-card ${hover_monitor_card === "search_uid" ? "is-active" : ""}`}
                        onMouseEnter={() =>
                          this.setState({ hover_monitor_card: "search_uid" })
                        }
                        onMouseLeave={() => this.setState({ hover_monitor_card: "" })}
                      >
                        <button
                          type="button"
                          className={`pu-om-mode ${filter_search_mode === "uid" ? "active" : ""}`}
                          onClick={() => this.setSearchMode("uid")}
                        >
                          <span className="icon">{"\uf084"}</span>
                        </button>
                        <div className="market-monitor-tooltip">
                          <div
                            className="fw-semibold mb-1"
                            style={{ fontSize: 13, color: "#8a5300" }}
                          >
                            UID Search
                          </div>
                          <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                            Search by exact{" "}
                            <span className="fw-semibold">transaction UID</span> for a
                            single record.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Process Type</span>
                  <Select
                    className="form-control"
                    placeholder="Process Type"
                    options={PROCESS_TYPE_OPTIONS}
                    value={filter_process_type}
                    onChange={(v) => this.setState({ filter_process_type: v })}
                    default={false}
                  />
                </div>
                <div className="pu-om-field">
                  <span className="pu-om-field-label">Order Source</span>
                  <Select
                    className="form-control"
                    placeholder="Order Source"
                    options={ORDER_SOURCE_OPTIONS}
                    value={filter_order_source}
                    onChange={(v) =>
                      this.setState({ filter_order_source: v, filter_market_order: false })
                    }
                    default={false}
                  />
                </div>
                <div className="pu-om-field pu-om-field-date">
                  <span className="pu-om-field-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    max={filter_end_date}
                  />
                </div>
                <div className="ar-toolbar-actions pu-om-filter-actions">
                  <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                    <span className="icon me-2">{"\uf002"}</span>Search
                  </button>
                  <button className="ar-btn-ghost" onClick={this.ResetFilters}>
                    <span className="icon me-2">{"\uf2ea"}</span>Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card pu-om-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Orders
                </div>
                <div className="ar-table-caption">
                  {count > 0
                    ? `Showing ${(page - 1) * page_size + 1}–${Math.min(
                        page * page_size,
                        count,
                      )} of ${count}`
                    : "No results"}
                  {table_updated_at ? (
                    <span className="ms-2">&middot; Updated {table_updated_at}</span>
                  ) : null}
                  {filter_market_order && (
                    <button
                      type="button"
                      className="pu-om-chip ms-2"
                      title="Clear Market Order filter"
                      onClick={this.ResetFilters}
                    >
                      <span className="icon me-1">{"\uf07a"}</span>
                      Market Order filter
                      <span className="icon ms-2">{"\uf00d"}</span>
                    </button>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <button
                  type="button"
                  className="pu-om-ctl"
                  onClick={() => {
                    this.Get(page, { silent: true });
                  }}
                >
                  <span className="icon me-1">{""}</span>Refresh
                </button>
                <button
                  type="button"
                  className={`pu-om-ctl ${table_auto_refresh ? "active" : ""}`}
                  onClick={() => {
                    this.ToggleTableAutoRefresh();
                  }}
                >
                  <span className="icon me-1">{""}</span>
                  {table_auto_refresh ? `Auto ${table_refresh_countdown}s` : "Auto"}
                </button>
                <button
                  type="button"
                  className="pu-om-ctl"
                  disabled={!!this.state.export_progress}
                  title="Export invoices of all orders matching the current filter (paid only) as one PDF"
                  onClick={this.ExportInvoiceAll}
                >
                  <span className="icon me-1">{"\uf019"}</span>
                  {this.state.export_progress
                    ? this.state.export_progress.total
                      ? `Exporting ${this.state.export_progress.done}/${this.state.export_progress.total}`
                      : "Preparing..."
                    : "Export Invoice All"}
                </button>
                <Select
                  className="form-control pu-om-rows"
                  placeholder="Rows"
                  options={PAGE_SIZE_OPTIONS.map((size) => ({
                    value: size,
                    label: `${size} rows`,
                  }))}
                  value={page_size}
                  onChange={(v) => {
                    this.setPageSize(Number(v));
                  }}
                />
                <Dropdown autoClose="outside" align="end">
                  <Dropdown.Toggle className="pu-om-ctl" id="order-columns">
                    <span className="icon me-1">{""}</span>Columns
                    <span className="pu-om-ctl-count">
                      {visibleColumns.length}/{columnDefs().length}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="pu-action-menu"
                    style={{ minWidth: 190, maxHeight: 340, overflowY: "auto" }}
                  >
                    <label className="pu-om-col fw-bold">
                      <input
                        type="checkbox"
                        className="form-check-input m-0 me-2"
                        checked={columnDefs().every((column) =>
                          this.isColumn(column.key),
                        )}
                        onChange={(e) => {
                          this.toggleAllColumns(e.target.checked);
                        }}
                      />
                      All columns
                    </label>
                    <div className="pu-action-sep" />
                    {columnDefs().map((column) => (
                      <label key={`column-${column.key}`} className="pu-om-col">
                        <input
                          type="checkbox"
                          className="form-check-input m-0 me-2"
                          checked={this.isColumn(column.key)}
                          onChange={() => {
                            this.toggleColumn(column.key);
                          }}
                        />
                        {column.label}
                      </label>
                    ))}
                    <div className="pu-action-sep" />
                    <button
                      type="button"
                      className="pu-om-col pu-om-col-reset"
                      onClick={() => {
                        this.resetColumns();
                      }}
                    >
                      Reset to default
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div
              className="table-responsive hide-scrollbar"
              style={{ minHeight: 300, msOverflowStyle: "none", scrollbarWidth: "none" }}
            >
              <table className="table table-hover ar-table pu-table">
                <thead>
                  <tr>
                    {this.isColumn("time") && <td className="text-nowrap">Time</td>}
                    {this.isColumn("ref_no") && <td className="text-nowrap">RefNo</td>}
                    {this.isColumn("ref_qr") && <td className="text-nowrap">RefQR</td>}
                    {this.isColumn("customer") && (
                      <td className="text-nowrap">Customer</td>
                    )}
                    {this.isColumn("bank") && <td className="text-nowrap">Bank</td>}
                    {this.isColumn("amount") && (
                      <td className="text-nowrap text-end">Amount</td>
                    )}
                    {this.isColumn("status_payment") && (
                      <td className="text-nowrap text-center wpx-130">
                        Status Payment
                      </td>
                    )}
                    {this.isColumn("status_order") && (
                      <td className="text-nowrap text-center wpx-100">Status Order</td>
                    )}
                    {this.isColumn("actions") && (
                      <td className="order-marketplace.update text-nowrap text-center td-actions">
                        Actions
                      </td>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loaded && data?.length === 0 ? (
                    <tr>
                      <td colSpan={visibleColumns.length || 1}>
                        <div className="ar-empty">
                          <span className="icon me-2">{""}</span>No data
                        </div>
                      </td>
                    </tr>
                  ) : (
                    data?.map((item, index) => (
                      <tr
                        key={`array-${index}`}
                        className={`${index === select ? "pu-row-selected" : ""} ${
                          focusedRowIndex === index ? "table-focus-row" : ""
                        }`}
                        onDoubleClick={() => {
                          this.setState({
                            select: select === index ? -1 : index,
                          });
                        }}
                      >
                        {this.isColumn("time") && (
                          <td data-label="Time" className="text-nowrap">
                            <div className="d-inline-flex align-items-center">
                              <span className="pu-mono">
                                {format_date(item.created_at, "dd/mm/yy hh:mm", "en")}
                              </span>
                              {this.renderMarketBadge(item)}
                              {this.renderOrderSourceBadge(item)}
                            </div>
                          </td>
                        )}
                        {this.isColumn("ref_no") && (
                          <td data-label="RefNo" className="text-nowrap py-1">
                            <div className="d-inline-flex align-items-center flex-wrap">
                              <div style={item.ref_no_refund ? { height: 14 } : undefined}>
                                <CopyCell value={item.ref_no} className="pu-code" />
                              </div>
                              {item.ref_no_refund && (
                                <small className="pu-sub w-100">
                                  refund no: {item.ref_no_refund}
                                  <span className="icon ms-1 text-primary pointer">
                                    {""}
                                  </span>
                                </small>
                              )}
                            </div>
                          </td>
                        )}
                        {this.isColumn("ref_qr") && (
                          <td data-label="RefQR" className="text-nowrap py-1">
                            <CopyCell
                              value={item.qrs?.reference_id || item.reference_id}
                              className="pu-code"
                            />
                          </td>
                        )}
                        {this.isColumn("customer") && (
                          <td data-label="Customer" className="text-nowrap py-1">
                            <div>
                              <div className="pu-name d-flex align-items-center">
                                {item.customer?.name_en || "-"}
                                <div
                                  className={`ms-2 inline-help-trigger ${this.state.hover_info_index === index ? "is-active" : ""}`}
                                  style={{
                                    background: "transparent",
                                    width: 16,
                                    height: 16,
                                    color:
                                      this.state.hover_info_index === index
                                        ? "#475467"
                                        : "#98a2b3",
                                  }}
                                  onMouseEnter={(event) => {
                                    this.setState({ hover_info_index: index });
                                    this.showInlineHelpPopup(event, {
                                      title: "Customer IDs",
                                      titleColor: "#344054",
                                      lines: [
                                        `originID: ${item.customer?.gateway_register?.[0]?.customer_id ?? "-"}`,
                                        `payoutID: ${item.customer?.gateway_register?.[0]?.uid ?? "-"}`,
                                      ],
                                      copyable: true,
                                    });
                                  }}
                                  onMouseLeave={() => {
                                    this.setState({ hover_info_index: -1 });
                                    this.hideInlineHelpPopup();
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.copyInlineHelpText(
                                      [
                                        `originID: ${item.customer?.gateway_register?.[0]?.customer_id ?? "-"}`,
                                        `payoutID: ${item.customer?.gateway_register?.[0]?.uid ?? "-"}`,
                                      ].join("\n"),
                                    );
                                  }}
                                >
                                  {StatusIcon("info")}
                                </div>
                              </div>
                              <div className="pu-sub">
                                {item.broker?.name_en || item.broker?.name_th || "-"}
                              </div>
                            </div>
                          </td>
                        )}
                        {this.isColumn("bank") && (
                          <td data-label="Bank" className="text-nowrap py-1">
                            {item.bank_code &&
                            global.bank.find((e) => e.value === item.bank_code) ? (
                              <div className="pu-bank">
                                <img
                                  alt="bank"
                                  src={require(
                                    `../../assets/images/bank/${global.bank.find((b) => b.value === item.bank_code)?.icon || "bank.png"}`,
                                  )}
                                />
                                <div>
                                  <div className="pu-bank-code">{item.bank_code}</div>
                                  <div className="pu-sub pu-mono">
                                    {item.bank_account_number || "-"}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <span className="pu-none">-</span>
                            )}
                          </td>
                        )}
                        {this.isColumn("amount") && (
                          <td data-label="Amount" className="text-nowrap text-end">
                            <div className="pu-amount pu-amount-gold">
                              {toFixed(item.amount, 2)}
                            </div>
                          </td>
                        )}
                        {this.isColumn("status_payment") && (
                          <td data-label="Status Payment" className="text-nowrap text-center py-1">
                            <div className="d-flex align-items-center justify-content-center">
                              {item.ref_no_refund && item.status === "success"
                                ? Status("refund", "info")
                                : isExpiredCancel(item.status, item.status_reason)
                                  ? // expired is a timeout, not a rejection: keep it
                                    // neutral so red stays reserved for real failures
                                    Status("cancel", "secondary")
                                  : StatusTnx(item.status)}
                              {["cancel", "success"].includes(item.status) &&
                              !(item.ref_no_refund && item.status === "success") ? (
                                <div
                                  className={`ms-1 inline-help-trigger ${this.state.hover_index === index ? "is-active" : ""}`}
                                  style={{
                                    background: "transparent",
                                    width: 16,
                                    height: 16,
                                    color: StatusReason(item.status, item.status_reason)
                                      .color,
                                  }}
                                  onMouseEnter={(event) => {
                                    this.setState({ hover_index: index });
                                    this.showInlineHelpPopup(event, {
                                      title: StatusReason(item.status, item.status_reason)
                                        .title,
                                      titleColor: StatusReason(
                                        item.status,
                                        item.status_reason,
                                      ).color,
                                      lines: [item.status_reason || "-"],
                                      copyable: true,
                                    });
                                  }}
                                  onMouseLeave={() => {
                                    this.setState({ hover_index: -1 });
                                    this.hideInlineHelpPopup();
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.copyInlineHelpText(item.status_reason);
                                  }}
                                >
                                  {StatusIcon(
                                    StatusReason(item.status, item.status_reason).icon,
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </td>
                        )}
                        {this.isColumn("status_order") && (
                          <td data-label="Status Order" className="text-nowrap text-center py-1">
                            <div className="d-flex align-items-center justify-content-center">
                              {this.renderStatusBadge(item)}
                            </div>
                          </td>
                        )}
                        {this.isColumn("actions") && (
                          <td data-label="Actions" className="order-marketplace.update text-center td-actions">
                            <Dropdown align="end">
                              <Dropdown.Toggle
                                className="pu-action-toggle"
                                id={`order-actions-${index}`}
                              >
                                Action
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                <Dropdown.Item
                                  className="pu-action-item"
                                  onClick={() => {
                                    // ล้างของ order ก่อนหน้า กันเห็นข้อมูลปนระหว่างรอโหลด
                                    this.setState({ detail: null, modal_detail: true });
                                    this.GetByID(item.order?.uid);
                                  }}
                                >
                                  <span className="icon">{""}</span>Detail
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="pu-action-item order-marketplace.update"
                                  onClick={async () => {
                                    this.setState({ detail: null });
                                    const [current] = await Promise.all([this.GetByID(item.order?.uid), this.LoadProvince()]);
                                    if (!current) return; // โหลด order ไม่สำเร็จ ไม่เปิด modal ที่ช่องว่าง (กันส่งค่าว่างไปล้างที่อยู่)
                                    this.setState({
                                      // ค่าตอนเปิด modal ใช้เทียบว่าผู้ใช้แก้ที่อยู่จริงไหม
                                      edit_origin: {
                                        address: current?.address || "",
                                        sub_district: current?.sub_district || "",
                                        district: current?.district || "",
                                        province: current?.province || "",
                                        zipcode: current?.zipcode || "",
                                      },
                                      edit_address: current?.address || "",
                                      edit_sub_district: current?.sub_district || "",
                                      edit_district: current?.district || "",
                                      edit_province: current?.province || "",
                                      edit_zipcode: current?.zipcode || "",
                                      order_status: item.order?.order_status,
                                      order_tracking_list: "",
                                      order_uid: item.order?.uid,
                                      modal_update: true,
                                    });
                                  }}
                                >
                                  <span className="icon">{""}</span>Update
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>

        {/* UPDATE */}
        <Modal
          show={modal_update}
          onHide={() => this.setState({ modal_update: false })}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Marketplace</div>
              <h5 className="fw-bold mb-0">
                Update Order{" "}
                {detail?.order_no ? (
                  <span className="pu-currency-tag">#{detail.order_no}</span>
                ) : null}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body pu-om-modal-body">
            {this.renderOrderInfo(detail, true)}

            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>สถานะสินค้า
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-6">
                  <label className="pr-label">สถานะสินค้า</label>
                  <Select
                    className="form-control pr-input"
                    placeholder="สถานะสินค้า..."
                    options={[
                      { value: "pending", label: "รอชำระเงิน" },
                      { value: "preparing", label: "จัดเตรียมสินค้า" },
                      { value: "delivering", label: "อยู่ในระหว่างส่งสินค้า" },
                      { value: "success", label: "จัดส่งแล้ว" },
                      { value: "returned", label: "คืนสินค้า" },
                      { value: "cancel", label: "ยกเลิก" },
                    ]}
                    value={order_status}
                    onChange={(v) => this.setState({ order_status: v })}
                  />
                </div>
                {!isDigitalOrder(detail) && ["delivering", "success"].includes(order_status) && (
                  <div className="col-12 col-md-6">
                    <label className="pr-label">หมายเลขส่งสินค้า</label>
                    {order_status === "success" ? (
                      <div className="pu-kv-value pt-2">{order_tracking_list || "-"}</div>
                    ) : (
                      <input
                        type="text"
                        className="form-control pr-input"
                        placeholder="หมายเลขส่งสินค้า..."
                        onChange={(e) => {
                          this.setState({ order_tracking_list: e.target.value });
                        }}
                        value={order_tracking_list}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill order-marketplace.update"
              onClick={() => {
                this.Update();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* DETAIL */}
        <Modal
          show={modal_detail}
          onHide={() => this.setState({ modal_detail: false })}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Marketplace</div>
              <h5 className="fw-bold mb-0">
                รายละเอียดการสั่งซื้อ{" "}
                {detail?.order_no ? (
                  <span className="pu-currency-tag">#{detail.order_no}</span>
                ) : null}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body pu-om-modal-body">
            {this.renderOrderInfo(detail, false)}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
